import Vue from 'vue'
import axios from 'axios'
export const ServiceBus = new Vue({
  data: {
    api_server: '',
    auth: null,
  },
  methods: {
    setApi(api) {
      const vm = this
      vm.api_server = api
    },

    setAuth(auth) {
      const vm = this
      vm.auth = auth
    },

    checkTkn(data) {
      if (data.hasOwnProperty('error')) {
        if (data.error.text == 'NO AUTH') {
          return false
        } else {
          alert(data.text)
        }
        return false
      }
      return true
    },

    generateUniqeID(cod_user, name, surname) {
      return (
        cod_user +
        '-' +
        Math.floor(Date.now() / 1000) +
        (name + '000').substring(0, 3) +
        (surname + '000').substring(0, 3)
      )
    },

    bitExtracted(number, k, p) {
      return ((1 << k) - 1) & (number >> (p - 1))
    },

    decodeAnalogs(item) {
      const vm = this
      let n1 = item.a1 / 16
      let n2 = item.a2 / 16
      let n3 = item.a3 / 16
      let analogs = {}

      if (item.slot) {
        analogs.slot = item.slot
      } else {
        analogs.slot = 0
      }
      analogs.date = item.date_rec
      analogs.values = []
      analogs.values.push(vm.bitExtracted(n1, 2, 7)) // status
      analogs.values.push(vm.bitExtracted(n2, 2, 7)) // overspeed

      analogs.values.push(vm.bitExtracted(n2, 2, 5)) // d1_card
      analogs.values.push(vm.bitExtracted(n1, 3, 1)) // d1_work
      analogs.values.push(vm.bitExtracted(n2, 4, 1)) // d1_times

      analogs.values.push(vm.bitExtracted(n3, 2, 5)) // d2_card
      analogs.values.push(vm.bitExtracted(n1, 3, 4)) // d2_work
      analogs.values.push(vm.bitExtracted(n3, 4, 1)) // d2_times
      return analogs
    },

    async _uploadFile(selectedFile) {
      const vm = this
      if (!selectedFile) {
        alert('Please select a file!')
        return
      }

      // Create a FormData object and append the file
      let formData = new FormData()
      formData.append('file', selectedFile)

      try {
        // Make a POST request with axios
        console.log('chiamo api')
        let response = await axios.post(
          'https://www.sovecotech.com/media/upload.php',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        // Handle the response
        console.log('File uploaded successfully:', response.data)
        return response.data
      } catch (error) {
        console.error('Error uploading file:', error)
      }
    },

    async _doGetPos(tags, cod, start, end) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'get_pos',
          {
            filters: tags,
            cod: cod,
            start: start,
            end: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return response.data
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },

    async _doGetDrivers() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_drivers/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async _doGetVehicle(cod) {
      const vm = this
      let apiserver = vm.api_server + 'get_vehicle/' + cod

      try {
        const response = await axios.get(apiserver, {
          headers: {
            Authorization: vm.auth.tkn,
          },
        })
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
        return null
      }
      return null
    },

    async _doGetVehicles() {
      const vm = this
      let apiserver
      if (vm.auth.tipo === 3) {
        apiserver =
          vm.api_server +
          'get_vehicles_filter/' +
          vm.auth.cod +
          '/' +
          vm.auth.vehicles
      } else {
        apiserver = vm.api_server + 'get_vehicles/' + vm.auth.cod
      }
      try {
        const response = await axios.get(apiserver, {
          headers: {
            Authorization: vm.auth.tkn,
          },
        })
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
        return []
      }
      return []
    },

    async _getActia() {
      const vm = this

      try {
        const response = await axios.get(
          vm.api_server + '/user/actia/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return null
    },

    async _doInsertCredenzialiActia(data) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_actia_credenziali',
          data,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async _doGetTags() {
      const vm = this
      try {
        const response = await axios.get(vm.api_server + 'get_tags', {
          headers: {
            Authorization: this.auth.tkn,
          },
        })
        if (this.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
        return []
      }
      return []
    },

    async _doGetPois() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_pois/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data) {
            return response.data
          }
        }
      } catch (e) {
        console.log(e)
        return []
      }
      return []
    },

    async _getStoryData(cod, start, end) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'get_tacho',
          {
            cod: cod,
            start: start.toMysqlString(),
            end: end.toMysqlString(),
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error _doGetStoryData' + e)
        return null
      }
      return null
    },

    //carica il data story più recente
    async _getLastDataStory(cod) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'get_tacho_last',
          {
            cod: cod,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          let result = response.data
          result.analogs = vm.decodeAnalogs(response.data)
          return result
        }
      } catch (e) {
        console.log('error _doGetLastDataPos' + e)
        return null
      }
      return null
    },

    // async _doTestAuth() {
    //   const vm = this
    //   let apiserver = ''
    //   apiserver = vm.api_server + 'test_headers'

    //   try {
    //     const response = await axios.get(apiserver, {
    //       headers: {
    //         Authorization: vm.auth.tkn,
    //       },
    //     })

    //     return response.data
    //   } catch (e) {
    //     console.log('error ' + e)
    //   }
    //   return []
    // },

    async _doGetAbbinamenti(distance) {
      const vm = this
      let apiserver =
        vm.api_server + 'get_abbinamenti/' + vm.auth.cod + '/' + distance

      console.log(apiserver)
      try {
        const response = await axios.get(apiserver, {
          headers: {
            Authorization: vm.auth.tkn,
          },
        })
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },

    async _doGetLastPos() {
      const vm = this
      let apiserver = ''
      if (vm.auth.tipo === 3) {
        apiserver =
          vm.api_server +
          'get_last_pos_filter/' +
          vm.auth.cod +
          '/' +
          vm.auth.vehicles
      } else {
        apiserver = vm.api_server + 'get_last_pos/' + vm.auth.cod
      }
      try {
        const response = await axios.get(apiserver, {
          headers: {
            Authorization: vm.auth.tkn,
          },
        })
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },
    async _doGetPosCalcBIS(cod, start, end) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'get_pos_calc',
          {
            cod: cod,
            start: start.toMysqlString(),
            end: end.toMysqlString(),
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },

    async _doSaveVehicleID(cod, vehicle_id) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'replace_vehicle_id',
          {
            cod: cod,
            vehicle_id: vehicle_id,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },

    async _getLastPosVehicle(cod) {
      const vm = this

      try {
        const response = await axios.post(
          vm.api_server + 'get_last_pos_vehicle',
          {
            cod: cod,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error _getLastPosVehicle' + e)
        return null
      }
      return null
    },

    _doCreateReport(icard, start, end, elements) {
      const vm = this
      const summa = function (acc, obj) {
        return acc + obj.min
      }
      const orderDesc = function (a, b) {
        return b.min - a.min
      }

      const filterActivity = function (activity) {
        return function (item) {
          return item.v === activity
        }
      }
      let reportObj = {}

      reportObj.icard = icard
      reportObj.guida = elements.filter(filterActivity(3))

      if (reportObj.guida.length > 0) {
        reportObj.guida_tot = reportObj.guida.reduce(summa, 0)
        reportObj.guida_ord = [...reportObj.guida]
        reportObj.guida_ord.sort(orderDesc)
      } else {
        reportObj.guida_ord = []
      }

      reportObj.riposo = elements.filter(filterActivity(0))
      if (reportObj.riposo.length > 0) {
        reportObj.riposo_tot = reportObj.riposo.reduce(summa, 0)
        reportObj.riposo_ord = [...reportObj.riposo]
        reportObj.riposo_ord.sort(orderDesc)
      } else {
        reportObj.riposo_ord = []
      }

      reportObj.lavoro = elements.filter(filterActivity(2))
      if (reportObj.lavoro.length > 0) {
        reportObj.lavoro_tot = reportObj.lavoro.reduce(summa, 0)
        reportObj.lavoro_ord = [...reportObj.lavoro]
        reportObj.lavoro_ord.sort(orderDesc)
      } else {
        reportObj.lavoro_ord = []
      }

      reportObj.disp = elements.filter(filterActivity(1))
      if (reportObj.disp.length > 0) {
        reportObj.disp_tot = reportObj.disp.reduce(summa, 0)
        reportObj.disp_ord = [...reportObj.disp]
        reportObj.disp_ord.sort(orderDesc)
      } else {
        reportObj.disp_ord = []
      }

      reportObj.err = elements.filter(filterActivity(6))
      if (reportObj.err.length > 0) {
        reportObj.err_tot = reportObj.err.reduce(summa, 0)
        reportObj.err_ord = [...reportObj.err]
        reportObj.err_ord.sort(orderDesc)
      } else {
        reportObj.err_ord = []
      }

      return reportObj
    },

    async _getTacoCardGroup(cod_user, start, end) {
      const vm = this
      try {
        // DESC
        const response = await axios.post(
          vm.api_server + 'get_tacocard_group',
          {
            cod_user: cod_user,
            start: start,
            end: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          let arry2 = []
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              let item = {}
              let str = element.message.replace(/ +(?= )/g, '')
              ;(item.cod = element.cod), (item.date = new Date(element.date))
              item.slots = []
              item.slots.push(str.split(' ')[2])
              item.slots.push(str.split(' ')[3])
              arry2.push(item)
            })
          }
          return arry2
        }
      } catch (e) {
        console.log('error _getTacoCardGroup' + e)
        return null
      }
      return null
    },

    async _getTacoCardRangeObj(cod, start, end) {
      const vm = this
      try {
        // DESC
        const response = await axios.post(
          vm.api_server + 'get_tacho_card_range',
          {
            cod: cod,
            start: start.toMysqlString(),
            end: end.toMysqlString(),
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          let arry2 = []
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              let item = {}
              let str = element.message.replace(/ +(?= )/g, '')
              item.date = new Date(element.date)
              item.slots = []
              item.slots.push(str.split(' ')[2])
              item.slots.push(str.split(' ')[3])
              arry2.push(item)
            })
          }
          return arry2
        }
      } catch (e) {
        console.log('error _getTacoCardRange' + e)
        return null
      }
      return null
    },

    _analyzeTacoCardRange(data, cod, end) {
      let obj = {}

      obj.last = data[0]

      let nlist1 = []
      let nlist2 = []

      nlist1.push({
        id: -1,
        icard: data[data.length - 1].slots[0],
        start: data[data.length - 1].date,
        end: null,
        cod: cod,
        slot: 1,
      })
      nlist2.push({
        id: -1,
        icard: data[data.length - 1].slots[1],
        start: data[data.length - 1].date,
        end: null,
        cod: cod,
        slot: 2,
      })
      for (let i = data.length - 1; i >= 0; i--) {
        if (nlist1[0].icard !== data[i].slots[0]) {
          nlist1.unshift({
            id: i,
            icard: data[i].slots[0],
            start: data[i].date,
            end: null,
            cod: cod,
            slot: 1,
          })
        }
        if (nlist2[0].icard !== data[i].slots[1]) {
          nlist2.unshift({
            id: i,
            icard: data[i].slots[1],
            start: data[i].date,
            end: null,
            cod: cod,
            slot: 2,
          })
        }
      }

      let tdate = null

      for (let i = 0; i < nlist1.length; i++) {
        nlist1[i].end = tdate
        tdate = new Date(nlist1[i].start)
      }
      tdate = null
      for (let i = 0; i < nlist2.length; i++) {
        nlist2[i].end = tdate
        tdate = new Date(nlist1[i].start)
      }

      obj.slots1 = nlist1
      obj.slots2 = nlist2
      return obj
    },

    async _getDriverActivity(intervals, decode) {
      const vm = this
      let res = []
      let analogs = []
      for (let i = 0; i < intervals.length; i++) {
        let item = intervals[i]
        if (item.end === null) {
          item.end = new Date()
        }
        const activities = await vm._getStoryData(
          item.cod,
          item.start,
          item.end
        )

        activities.forEach((element) => {
          element.slot = intervals[i].slot
        })
        res = [...res, ...activities]
      }
      res.sort((a, b) => {
        if (a.date_rec < b.date_rec) {
          return -1
        }
        if (b.date_rec < a.date_rec) {
          return 1
        }
        return 0
      })
      if (decode) {
        res.forEach((item) => {
          analogs.push(vm.decodeAnalogs(item))
        })

        res = analogs
      }

      return res
    },

    async _getReportIcardDay(icard, theDate) {
      const vm = this
      let start = new Date(theDate)
      let end = new Date(theDate)
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)
      end.setHours(23)
      end.setMinutes(59)
      end.setSeconds(59)

      let result = {}
      result.key = theDate.getTime()
      result.date = theDate
      result.timeline = await ServiceBus._doGetActivityDriver(icard, start, end)
      result.report = await ServiceBus._doCreateReport(
        icard,
        start,
        end,
        result.timeline
      )

      return result
    },

    async _doGetActivityDriver(icard, start, end) {
      const vm = this

      console.log('PASS 3')
      console.log(icard)
      const intervals = await ServiceBus._getDriverActivityIntervals(
        icard,
        new Date(start),
        new Date(end)
      )
      console.log('pass 4')
      console.log('intervals', intervals)

      if (intervals.length === 0) {
        return []
      }
      let data = await vm._getDriverActivity(intervals, true)
      console.log('_getDriverActivity', data)
      let elements = vm._extractActivityElements2(data)
      console.log('_extractActivityElements2', elements)

      const res = vm._extractGraphInfo(
        elements,
        new Date(end) // end
      )
      if (res.length < 1) {
        return []
      }
      let today = new Date(end)
      today.setHours(0)
      today.setMinutes(0)
      today.setSeconds(0)
      let minAvail = (res[0].from - today) / 1000 / 60
      if (minAvail > 1) {
        let forcedRest = {}
        forcedRest.from = today
        forcedRest.to = res[0].from
        forcedRest.min = (forcedRest.to - forcedRest.from) / 1000 / 60
        forcedRest.id = 'AA'
        forcedRest.v = 0
        forcedRest.key = res[0].key
        forcedRest.slot = res[0].slot

        res.unshift(forcedRest)
      }
      const _tdy = new Date()
      if (_tdy.getTime() > end.getTime()) {
        let forcedRest = {}
        forcedRest = {}
        forcedRest.from = res[res.length - 1].to
        forcedRest.to = end
        forcedRest.min = (forcedRest.to - forcedRest.from) / 1000 / 60
        forcedRest.id = 'ZZ'
        forcedRest.v = 0
        forcedRest.key = res[0].key
        forcedRest.slot = res[0].slot
        res.push(forcedRest)
      }

      return res
    },

    _extractActivityElements2(data) {
      let ref = [-1, -1, -1, -1, -1, -1, -1, -1]
      let cur = [[], [], [], [], [], [], [], []]
      let elements = []
      let id = 0
      const createElement = (id, slot, key, value, date_from, date_to) => {
        const element = {}
        element.slot = slot
        element.id = id
        element.key = key
        element.v = value
        element.from = new Date(date_from)
        element.to = new Date(date_to)
        element.min = (element.to - element.from) / 1000 / 60
        return element
      }

      for (let i = 0; i < 8; i++) {
        cur[i].push(data[0])
      }

      for (let x = 0; x < data.length - 2; x++) {
        let item_a = data[x]
        let item_b = data[x + 1]

        for (let i = 0; i < 8; i++) {
          if (item_a.values[i] !== item_b.values[i]) {
            let element = createElement(
              id,
              item_a.slot,
              i,
              item_a.values[i],
              cur[i][0].date,
              item_a.date
            )
            elements.push(element)
            id++
            cur[i] = []
          }
          cur[i].push(item_b)
        }
      }
      for (let i = 0; i < 8; i++) {
        if (cur[i].length > 0) {
          let element = createElement(
            id,
            cur[i][0].slot,
            i,
            cur[i][0].values[i],
            cur[i][0].date,
            cur[i][cur[i].length - 1].date
          )
          elements.push(element)
        }
      }
      elements.sort((a, b) => {
        return a.key - b.key
      })
      return elements
    },

    _extractGraphInfo(data, dateday) {
      dateday.setHours(0)
      dateday.setMinutes(0)
      dateday.setSeconds(0)
      let endday = new Date(dateday)
      endday.setHours(23)
      endday.setMinutes(59)
      endday.setSeconds(59)

      let res = data.filter((item) => {
        return (
          item.from >= dateday &&
          item.to <= endday &&
          ((item.slot === 1 && item.key === 3) ||
            (item.slot === 2 && item.key === 5))
        )
      })
      if (res.length > 0) {
        if (res[0].from.getTime() > dateday.getTime()) {
          const sitem = {}
          sitem.from = new Date(dateday)
          sitem.to = new Date(res[0].from)
          sitem.key = 3
          sitem.v = 0
          sitem.min = (sitem.to - sitem.from) / 1000 / 60
          // res.unshift(sitem)
        }
      }
      return res
    },

    async _getDriverActivityIntervals(icard, start, end) {
      const vm = this
      let temp = await vm._getTacoCardVehicles(icard, start, end)
      let codList = vm._analyzeTacoCardVehicles(temp)
      let res = []

      const getIntervalsIcard = async (cod) => {
        const cardRange = await vm._getTacoCardRangeObj(cod.cod, start, end)
        const { slots1, slots2 } = vm._analyzeTacoCardRange(cardRange, cod.cod)
        let res = null
        if (cod.slot === 1) {
          res = slots1.filter((it) => it.icard === icard)
        }
        if (cod.slot === 2) {
          res = slots2.filter((it) => it.icard === icard)
        }
        return res
        //return [...slots1, ...slots2].filter((it) => it.icard === icard)
      }

      for (let i = 0; i < codList.length; i++) {
        const intervals = await getIntervalsIcard(codList[i])
        res = [...res, ...intervals]
      }
      return res
    },

    async _getTacoCardVehicles(icard, start, end) {
      const vm = this
      if (icard == 'EMPTY') return []
      try {
        const response = await axios.post(
          vm.api_server + '/get_tacho_card_vehicles',
          {
            icard: icard,
            start: start.toMysqlString(),
            end: end.toMysqlString(),
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          let arry2 = []
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              let item = {}
              let str = element.message.replace(/ +(?= )/g, '')
              item.cod = element.cod
              item.date = new Date(element.date)
              item.slot1 = str.split(' ')[2]
              item.slot2 = str.split(' ')[3]
              if (icard === item.slot1) {
                item.slot = 1
              } else if (icard === item.slot2) {
                item.slot = 2
              }
              arry2.push(item)
            })
          }
          return arry2
        }
      } catch (e) {
        console.log('error _getTacoCardRange' + e)
        return null
      }
      return null
    },

    _analyzeTacoCardVehicles(data) {
      if (data.length === 0) return []
      const res = [
        ...new Set(
          data.map((it) => ({
            cod: it.cod,
            slot: it.slot,
          }))
        ),
      ]
      return res
    },

    async _getMD5(value) {
      const vm = this
      try {
        const response = await axios.get(vm.api_server + 'md5/' + value)
        return response.data
      } catch (e) {
        console.log('error ' + e)
      }
      return null
    },

    async _deleteDupDriver(driver) {
      const vm = this

      try {
        const md5 = await vm._getMD5(
          driver.cod_user + driver.cognome + driver.nome + driver.nick
        )

        driver.id_unique = md5

        const response = await axios.delete(
          vm.api_server + 'delete_dup_driver/' + driver.id_unique,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )

        const response2 = await axios.post(
          vm.api_server + 'insert_sincro_driver/4',
          {
            cod_f: driver.cod_f,
            cod_user: driver.cod_user,
            cod_vehicle: driver.cod_vehicle,
            cognome: driver.cognome,
            nome: driver.nome,
            nick: driver.nick,
            email_1: driver.email_1,
            email_2: driver.email_2,
            phone_1: driver.phone_1,
            phone_2: driver.phone_2,
            fax_1: driver.fax_1,
            note_driver: driver.note_driver,
            id_unique: driver.id_unique,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return true
      } catch (e) {
        console.log('error ' + e)
      }
      return false
    },

    async _deleteDriver(driver) {
      const vm = this
      try {
        const response = await axios.delete(
          vm.api_server + 'delete_driver/' + driver.id,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )

        const response2 = await axios.post(
          vm.api_server + 'insert_sincro_driver/4',
          {
            cod_f: driver.cod_f,
            cod_user: driver.cod_user,
            cod_vehicle: driver.cod_vehicle,
            cognome: driver.cognome,
            nome: driver.nome,
            nick: driver.nick,
            email_1: driver.email_1,
            email_2: driver.email_2,
            phone_1: driver.phone_1,
            phone_2: driver.phone_2,
            fax_1: driver.fax_1,
            note_driver: driver.note_driver,
            id_unique: driver.id_unique,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return true
      } catch (e) {
        console.log('error ' + e)
      }
      return false
    },

    async _insertDriver(driver) {
      const vm = this

      await vm._deleteDupDriver(driver)

      try {
        const response = await axios.post(
          vm.api_server + 'insert_new_driver',
          {
            cod_f: driver.cod_f,
            cod_user: driver.cod_user,
            cod_vehicle: driver.cod_vehicle,
            cognome: driver.cognome,
            nome: driver.nome,
            nick: driver.nick,
            email_1: driver.email_1,
            email_2: driver.email_2,
            phone_1: driver.phone_1,
            phone_2: driver.phone_2,
            fax_1: driver.fax_1,
            note_driver: driver.note_driver,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return response.data
      } catch (e) {
        console.log('error ' + e)
      }

      return 'error'
    },

    async _updateDriver(driver) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'update_driver/' + driver.id,
          {
            cod_f: driver.cod_f,
            cod_user: driver.cod_user,
            cod_vehicle: driver.cod_vehicle,
            cognome: driver.cognome,
            nome: driver.nome,
            nick: driver.nick,
            email_1: driver.email_1,
            email_2: driver.email_2,
            phone_1: driver.phone_1,
            phone_2: driver.phone_2,
            fax_1: driver.fax_1,
            note_driver: driver.note_driver,
            id_unique: driver.id_unique,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return true
      } catch (e) {
        console.log('error ' + e)
      }
      return false
    },

    async _getDriver(id) {
      const vm = this
      try {
        const response = await axios.get(vm.api_server + 'get_driver/' + id, {
          headers: {
            Authorization: vm.auth.tkn,
          },
        })
        return response.data
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },

    async _getDrivers() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_drivers/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        return response.data
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },
  },
})
